var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.methods}},[_c('h3',[_vm._v(_vm._s(_vm.$t("forms.ticket.labels.payment_method")))]),_c('PaymentLogos'),_c('h3',[_vm._v(_vm._s(_vm.$t("forms.ticket.labels.via")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }